import {
  acbPriceSection,
  imfPriceSection,
  fscPriceSection,
  nacPriceSection,
  berPriceSection,
  vbcPriceSection,
  ryrPriceSection,
  vepPriceSection,
  dk2PriceSection,
  dk5PriceSection,
  tnkPriceSection,
} from '../../src/images';

export const content = {
  TNK: {
    title: ``,
    subtitle: 'Price & Value',
    section: `In a crowded market, you’ll often find single-ingredient formulas or lower potencies that may not address memory and cognition at once. Prices range anywhere from $25 to $50 for just a single-focus product. With <strong>Think Factor</strong> you get more:
<ul>
  <li>Focus, Memory, and Cognition for only $37.95 for 60 capsules (30-day supply when taking 2 capsules daily).</li>
  <li><strong>That’s about</strong> $1.27 per day for a full-spectrum solution that supports substantial brain and cognitive health.</li>
</ul>`,
    img: tnkPriceSection,
  },
  ACB: {
    title: ``,
    subtitle: 'Price & Value',
    section: `At $25.95 for 120 capsules (60 servings), each daily dose costs just $0.43. Compare that to many general supplements in the $30–$40 range for only a 30-day supply, and you’ll see why we’re so excited about this comprehensive formula.`,
    img: acbPriceSection,
  },
  FSE: {
    title: ``,
    subtitle: 'Price & Value',
    section: `$42.95 for 120 capsules—that’s a full 60-day supply with the recommended usage.Competitors often charge more for fewer servings or use generic ingredients.Your daily investment in your health is just $0.72 per day—less than the cost of a cup of coffee!`,
    img: fscPriceSection,
  },
  IMF: {
    title: ``,
    subtitle: 'Price & Value',
    section: `At $89 for 120 capsules (a 60-day supply), Immune Factors gives you premium, multi-ingredient coverage at roughly $1.48/day. Most general competitor products can run between $40–$60 for just a 30-day supply, often with fewer ingredients or lower potencies.`,
    img: imfPriceSection,
  },
  NAC: {
    title: ``,
    subtitle: 'Price & Value',
    section: `For only $21.95, you get 120 capsules—that’s a 60-day supply at the recommended usage. Broken down, it’s $0.37 per day to help support healthy detox, antioxidant defense, and immune function. Many NAC formulas in the marketplace range from $15 to $30 for just a 30-day supply, making our formula a standout value.`,
    img: nacPriceSection,
  },
  BER: {
    title: ``,
    subtitle: 'Price & Value',
    section: `<ul>
    <li>Cost: $32.95 for 60 capsules</li>
<li>Cost Per Day: <strong>Only</strong> about $1.10 for twice<strong>-daily use</strong></li>
<li>Competitive Advantage: Many competitor products in the market range from $25 to $45 for <strong>a 30-day supply. Our</strong> high-potency formula and clean ingredient list deliver exceptional value for your money.</li></ul>
`,
    img: berPriceSection,
  },
  VBC: {
    title: ``,
    subtitle: 'Price & Value',
    section: `At $22.95 for 120 capsules, you get a 60-day supply (when taken as directed), translating to about $0.38 per day—a significant savings compared to some premium competitors in the $25–$40 range for a single month’s supply.`,
    img: vbcPriceSection,
  },
  RYR: {
    title: ``,
    subtitle: 'Price & Value',
    section: `Other products may only offer Red Yeast Rice or CoQ10 alone. You’ll typically see prices in 
the $20–$40 range for a 30-day supply of similar supplements. Our formula delivers a full 60-
day supply at $46.95, that's just $0.78 per day making it a solid value for its quality and potency. Compare that to many single-ingredient formulas on the market that cost more per day and give you fewer ingredients!`,
    img: ryrPriceSection,
  },
  VEP: {
    title: ``,
    subtitle: 'Price & Value',
    section: `At just $22.95 for a 60-Day Supply it’s only $0.38 per day, an excellent value for high-potency, bioactive B vitamins specifically tailored to support cardiovascular health and energy. Comparable products often cost more for fewer servings, making Vessel Protection a top choice for cost-conscious consumers who value premium quality.`,
    img: vepPriceSection,
  },
  DK2: {
    title: `As low as <span class='pricePerDay'>$0.11</span> per day`,
    subtitle: 'Price & Value',
    section: `For $12.95, you’ll get a 120-capsule supply—about 11 cents per serving. It’s a small daily investment with the potential for major benefits to your bones, heart, and immune health. Other D3 supplements can cost anywhere from $18 to $25 for a 30- to 60-day supply. Some skip K2 entirely, or include it in tiny amounts. Our Advantage: We provide a complete D3 + K2 formula at a fraction of the typical cost, with higher potencies in a single daily dose.`,
    img: dk2PriceSection,
  },
  DK5: {
    title: `As low as <span class='pricePerDay'>$0.11</span> per day`,
    subtitle: 'Price & Value',
    section: `For $12.95, you’ll get a 120-capsule supply—about 11 cents per serving. It’s a small daily investment with the potential for major benefits to your bones, heart, and immune health. Other D3 supplements can cost anywhere from $18 to $25 for a 30- to 60-day supply. Some skip K2 entirely, or include it in tiny amounts. Our Advantage: We provide a complete D3 + K2 formula at a fraction of the typical cost, with higher potencies in a single daily dose.`,
    img: dk5PriceSection,
  },
};
